<template>
    <!-- Toggle -->
    <div class="header-section">
        <div class="selected-period" style="width: 20%;">
            <span>{{ selectedPeriodInfo }}</span>
        </div>
        <div class="period-toggle" style="width: 40%;">
            <button :class="{ active: period === 'daily' }" @click="onClickPeriod('daily')">Daily</button>
            <button :class="{ active: period === 'weekly' }" @click="onClickPeriod('weekly')">Weekly</button>
            <button :class="{ active: period === 'monthly' }" @click="onClickPeriod('monthly')">Monthly</button>
        </div>
        <div class="date-picker"
            style="display: flex; gap: 1rem; align-items: center; width: 40%;">
            <PlatoonDropdown id="ddPlatoon" :allow-all="isAdminRole" :selected="selectedPlatoonId"
                @selected-platoon-id="(selectedValue) => (selectedPlatoonId = selectedValue)" />

            <argon-input id="search" name="search" :value="searchText" type="text" placeholder="Search..."
                aria-label="Search" class="ms-3 mt-3" @input="(event) => (searchText = event.target.value)"
                @keyup.enter="searchByName()" />

            <Datepicker style="width: 50%;" v-model="selectedDate" dark auto-apply format="dd MMM yyyy"
                :max-date="new Date()" />
        </div>
    </div>

    <div v-if="topRankUsers && topStepsAndCalories" class="leaderboard d-flex justify-content-between"
        style="margin-left: 1rem;margin-right: 1rem;">
        <LeaderboardList style="width: 20%;" :users-data="topRankUsers.strain" boardType="strain"
            title="Fitness Leaders" subTitle="Leading the way on daily & workouts" :rankByIndex="false" />
        <LeaderboardList style="width: 20%;" :users-data="topRankUsers.recovery" boardType="recovery"
            title="Recovery Heroes" subTitle="Consistently prioritizing rest & recharge" :rankByIndex="false" />
        <LeaderboardList style="width: 20%;" :users-data="topRankUsers.sleep" boardType="sleep"
            title="Night Time Ninjas" subTitle="Keeping sleep patterns on track for better energy" :rankByIndex="false" />
        <LeaderboardList style="width: 20%;" :users-data="topStepsAndCalories.topCalories" boardType="calories"
            title="Calorie Champs" subTitle="Transfor every workout into a calorie-burning victory" :rankByIndex="false" />
        <LeaderboardList style="width: 20%;" :users-data="topStepsAndCalories.topSteps" boardType="steps"
            title="Step Stars" subTitle="Turning evry step into progress" :rankByIndex="false" />
    </div>

    <div>
        <LoadingScreen v-if="!topRankUsers || !topStepsAndCalories" :visible="!topRankUsers || !topStepsAndCalories"
            :rows="10" :fullScreen="true" :compact="false" :showSunrays="true" bg="#283335" rayColor="#1f2628" />
    </div>
</template>
<script>
import dayjs from "dayjs";
import Datepicker from "@vuepic/vue-datepicker";
import Constants from "@/helpers/constants";
import DateUtils from "@/helpers/dateUtils";
import ArgonInput from "@/shared/Controls/ArgonInput.vue";
import PlatoonDropdown from "../components/PlatoonDropdown.vue";
import LeaderboardList from "./LeaderboardList.vue";
import LoadingScreen from "./LoadingScreen.vue";
import emitter from "../../../helpers/eventBus";

export default {
    name: 'LeaderBoard',
    components: {
        LoadingScreen,
        LeaderboardList,
        Datepicker,
        PlatoonDropdown,
        ArgonInput,
    },
    data() {
        return {
            period: "daily",
            topPerformers: null,
            selectedPlatoonId: 2,
            searchText: '',
            isAdminRole: false,
            topStepsAndCalories: {
                topCalories: [],
                topSteps: []
            },
            topRankUsers: {
                strain: [],
                recovery: [],
                sleep: []
            },
            selectedDate: new Date(),
            selectedPeriodInfo: '',
            offsets: {
                strain: 0,
                recovery: 0,
                sleep: 0,
                calories: 0,
                steps: 0
            },
            chunkSize: 10,
            isLoading: false,
            allDataLoaded: {
                strain: false,
                recovery: false,
                sleep: false,
                calories: false,
                steps: false
            },
            page_num: 1,
        };
    },
    mounted() {
        this.resetAndFetchData();
        emitter.on("load-more-data", this.loadMoreDataForAllCategories);
    },
    beforeUnmount() {
        emitter.off(
            "load-more-data",
            this.loadMoreDataForAllCategories
        );
    },
    watch: {
        selectedDate() {
            this.resetAndFetchData();
        },
        selectedPlatoonId() {
            this.resetAndFetchData();
        }
    },
    methods: {
        resetAndFetchData() {
            this.topRankUsers = { strain: [], recovery: [], sleep: [] };
            this.topStepsAndCalories = { topCalories: [], topSteps: [] };
            this.offsets = { strain: 0, recovery: 0, sleep: 0, calories: 0, steps: 0 };
            this.allDataLoaded = { strain: false, recovery: false, sleep: false, calories: false, steps: false };
            this.page_num = 1;
            this.updateSelectedPeriodInfo();
            this.fetchDataByPeriod(this.period, true);
            this.fetchTopCandidates();
        },
        updateSelectedPeriodInfo() {
            if (this.period === 'weekly') {
                this.selectedPeriodInfo = `Leaderboard : ${DateUtils.getWeekRange(this.selectedDate)}`;
            } else if (this.period === 'monthly') {
                this.selectedPeriodInfo = `Leaderboard : ${DateUtils.formatDate(this.selectedDate, 'MMM YYYY')}`;
            } else { // daily
                this.selectedPeriodInfo = `Leaderboard : ${DateUtils.formatDate(this.selectedDate, Constants.TABLE_DOB_FORMAT)}`;
            }
        },
        onClickPeriod(selectedPeriod) {
            this.period = selectedPeriod;
            this.page_num = 1;
            this.resetData();
            this.updateSelectedPeriodInfo();
            this.fetchDataByPeriod(this.period);
            this.fetchTopCandidates();
        },
        resetData() {
            this.topRankUsers = { strain: [], recovery: [], sleep: [] };
            this.topStepsAndCalories = { topCalories: [], topSteps: [] };
            this.offsets = { strain: 0, recovery: 0, sleep: 0, calories: 0, steps: 0 };
            this.allDataLoaded = { strain: false, recovery: false, sleep: false, calories: false, steps: false };
        },
        fetchDataByPeriod(period) {
            let dtFrom = null;
            let days = 1;
            let dtTo = dayjs(this.selectedDate).utc().startOf("day").format(Constants.BUCKET_FORMAT);
            if (period === "daily") {
                //dtFrom = dayjs(this.selectedDate).subtract(1, 'days').utc().endOf("day").format(Constants.BUCKET_FORMAT);
                dtFrom = dtTo;
            } else if (period === "weekly") {
                dtFrom = dayjs(this.selectedDate).subtract(1, 'week').utc().endOf("week").format(Constants.BUCKET_FORMAT);
                days = 7;
            } else if (period === "monthly") {
                dtFrom = dayjs(this.selectedDate).subtract(1, 'month').utc().endOf("month").format(Constants.BUCKET_FORMAT);
                days = 30;
            }
            this.getUserPerformanceTrends(dtFrom, dtTo, days);
        },
        fetchTopCandidates() {
            let isSearchActive = (this.searchText && this.searchText.trim().length > 0) || (this.platoon_id && this.platoon_id !== -1);

            let request = {};
            request.period = this.period;
            request.offset = 10;
            request.chunkSize = 10;
            request.label = 'strain';
            request.day = dayjs(this.selectedDate).utc().startOf("day").format(Constants.BUCKET_FORMAT);
            request.platoon_id = this.selectedPlatoonId;
            request.search_term = this.searchText;
            request.page_num = isSearchActive ? 1 : this.page_num;

            this.$store.dispatch("user/topRankingUsers", request).then((data) => {
                //console.log('Top Ranking Users Data:', JSON.stringify(data));
                // this.topRankUsers = data;
                if(isSearchActive) {
                    // If search text is present, replace the existing data with the search results
                    this.topRankUsers.strain = [];
                    this.topRankUsers.recovery = [];
                    this.topRankUsers.sleep = [];
                    this.page_num = 1; // Reset to first page for search results
                }
                if(data && data.strain && data.strain.length > 0) {
                    this.topRankUsers.strain.push(...data.strain);
                }
                if(data && data.recovery && data.recovery.length > 0) {
                    this.topRankUsers.recovery.push(...data.recovery);
                }
                if(data && data.sleep && data.sleep.length > 0) {
                    this.topRankUsers.sleep.push(...data.sleep);
                }
            });
        },
        formatNum(num) {
            return new Intl.NumberFormat().format(num);
        },
        getUserPerformanceTrends(fromDate, toDate, days) {
            let isSearchActive = (this.searchText && this.searchText.trim().length > 0) || (this.platoon_id && this.platoon_id !== -1);
            this.$store
                .dispatch("data/topPerformingUsers", {
                    dt_from: fromDate,
                    dt_to: toDate,
                    days: days,
                    platoon_id: this.selectedPlatoonId,
                    search_term: this.searchText,
                    page_num: isSearchActive ? 1 : this.page_num,
                })
                .then((data) => {
                    // this.topStepsAndCalories = data.data;
                     if(isSearchActive) {
                        this.topStepsAndCalories.topCalories = [];
                        this.topStepsAndCalories.topSteps = [];    
                        this.page_num = 1; // Reset to first page for search results
                    }

                    if (data.data && data.data.topCalories && data.data.topCalories.length > 0) {
                        this.topStepsAndCalories.topCalories.push(...data.data.topCalories);
                    }
                    if (data.data && data.data.topSteps && data.data.topSteps.length > 0) {
                        this.topStepsAndCalories.topSteps.push(...data.data.topSteps);
                    }
                    //console.log('Top Steps and Calories Data:', JSON.stringify(this.topStepsAndCalories));
                });
        },
        loadMoreDataForAllCategories() {
            console.log("Load more data event received in LeaderBoard.vue");
            this.handleLoadMore("strain");
        },
        handleLoadMore(boardType) {
            if (this.isLoading || this.allDataLoaded[boardType]) return;

            this.offsets[boardType] += this.chunkSize;
            this.page_num += 1;
            this.fetchDataByPeriod(this.period);
            this.fetchTopCandidates();
        },
        searchByName() {
            if (this.searchText.trim().length == 0) {
                this.resetAndFetchData();
            } else {
                this.fetchDataByPeriod(this.period);
                this.fetchTopCandidates();
            }
        },
    },
};
</script>

<style scoped>
.header-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;
    padding-left: 1.5rem;
    padding-right: 1rem;
}

.selected-period {
    font-weight: 700;
    font-size: 1rem;
    letter-spacing: .02em;
}

/* Toggle */
.period-toggle {
    display: flex;
    justify-content: center;
    gap: 10px;
    margin-bottom: 1rem;
}

.period-toggle button {
    font-weight: 700;
    font-size: 13px;
    letter-spacing: .02em;
    color: #cfe1ff;
    background: linear-gradient(180deg, #17243a, #0f1a2a);
    border: 1px solid #20314c;
    border-radius: 999px;
    padding: 8px 18px;
    cursor: pointer;
}

.period-toggle button.active {
    color: #0c1a2e;
    background: linear-gradient(180deg, #ff77a9, #ff5f8f);
    border-color: #ff4f86;
    box-shadow: 0 8px 20px rgba(255, 95, 143, .35);
}
</style>